module.exports = __webpack_public_path__ + "img/1.7a8e2c2.png";